<template>
  <div>
    <input type="text" class="form-control form-control-sm d-block" style="/*width:20%;*/" placeholder="Buscar" v-model.trim="textInput">
  </div>
</template>
<script>
export default {
  data() {
    return {
      textInput: '',
      resultadoBusqueda: []
    }
  },
  props:{
      data: null
  },
  mounted(){},
  methods:{
    filtrado(){
        // obtengo texto del input, es necesario limpiar cada vez q filtre para q no dupliq resultados
        let texto = this.textInput.toLowerCase();
        this.resultadoBusqueda = [];

        // for(comparo el nombre del tramite con el texto del input)
        for(let item of this.data){
            let titulo = item.titulo.toLowerCase();

            // si hay resultados, armo objeto y lo guardo en el array de resultados
            if(titulo.indexOf(texto) !== -1){

                let obj = item;
                this.resultadoBusqueda.push(obj);
            }
        }
    }
  },
  watch:{
    textInput: function(){
      if(this.textInput == '') {
        this.resultadoBusqueda = this.data
      }
      else this.filtrado();
    },
    resultadoBusqueda(){
      this.$emit("datos", this.resultadoBusqueda);
    },
    data(){
      this.resultadoBusqueda = this.data;
      this.$emit("datos", this.resultadoBusqueda);
    }
  }

}
</script>
